import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import SelectableChip from "../../components/SelectableChip";
import useStyles from "./SearchCategoryChips.styles";


const SearchCategoryChips = ({ chips, category, setCategory }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {chips.map((chip) => (
        <SelectableChip
          key={chip.value}
          text={chip.label}
          className={clsx("type-option", classes.chip)}
          variant="primary"
          onClick={() => setCategory(chip.value)}
          selected={category === chip.value}
        />
      ))}
    </div>
  );
};

SearchCategoryChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  category: PropTypes.string.isRequired,
  setCategory: PropTypes.func.isRequired,
};

export default SearchCategoryChips;
